import { useQueryAndSubscriptionWithPollingFallback } from '@vitvio/helpers';
import { useMemo } from 'react';
import { useDemoFunctionalityContext } from '@vitvio/demo-functionality';
import type { ORColumnQuery } from '../graphql/__generated__/ORColumnQuery.graphql';
import type { ORColumnSubscription } from '../graphql/__generated__/ORColumnSubscription.graphql';
import { orColumnQuery, orColumnSubscription } from '../graphql';
import { OPERATING_ROOM_POLLING_INTERVAL_MS } from '../../constants';

export interface UseORDataProps {
  id: string;
  datetimeStart: ORColumnQuery['variables']['datetimeStart'];
  datetimeEnd: ORColumnQuery['variables']['datetimeEnd'];
}

export function useORData({ id, datetimeStart, datetimeEnd }: UseORDataProps) {
  const { globalReloadKey } = useDemoFunctionalityContext();
  const queryVariables = useMemo(
    () => ({
      id,
      datetimeStart,
      datetimeEnd,
    }),
    [id, datetimeStart, datetimeEnd],
  );

  return useQueryAndSubscriptionWithPollingFallback<ORColumnQuery, ORColumnSubscription>(
    orColumnQuery,
    orColumnSubscription,
    {
      queryVariables,
      subscriptionVariables: { id },
      queryKey: `operating-room-${id}-${globalReloadKey}`,
      pollingInterval: OPERATING_ROOM_POLLING_INTERVAL_MS,
    },
  );
}
